import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "./components/SEO";
import Layout from "./components/Layout";
import HomePage from "./components/HomePage";
import ServicesPage from "./components/ServicesPage";
import AboutPage from "./components/AboutPage";
import FAQPage from "./components/FAQPage";
import QuotePage from "./components/QuotePage";
import GalleryPage from "./components/GalleryPage";
import BlogPage from "./components/BlogPage";
import BlogArticlePage from "./components/BlogArticlePage";
import ServiceAreaPage from "./components/ServiceAreaPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/quote" element={<QuotePage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogArticlePage />} />
              <Route path="/service-area/:areaSlug" element={<ServiceAreaPage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
